import type * as EventTypes from '../event-types/factory_contract';
import EVENT_TYPE from '../event-data/factory_contract.json';
import type {ContractPromise} from "@polkadot/api-contract";
import type {ApiPromise} from "@polkadot/api";
import {handleEventReturn} from "@arthswap/typechain-types";
export { EVENT_TYPE }

export default class EventsClass {
	private __nativeContract : ContractPromise;
	private __api : ApiPromise;

	constructor(
		nativeContract : ContractPromise,
		api : ApiPromise,
	) {
		this.__nativeContract = nativeContract;
		this.__api = api;
	}

	public subscribeOnPairCreatedEvent(callback : (event : EventTypes.PairCreated) => void) {
		const callbackWrapper = (args: any[], event: any) => {
			const _event: Record < string, any > = {};

			for (let i = 0; i < args.length; i++) {
				_event[event.args[i]!.name] = args[i]!.toJSON();
			}

			callback(handleEventReturn(_event, EVENT_TYPE['PairCreated']) as EventTypes.PairCreated);
		};

		return this.__subscribeOnEvent(callbackWrapper, (eventName : string) => eventName == 'PairCreated');
	}

	public subscribeOnPairCreateLockedEvent(callback : (event : EventTypes.PairCreateLocked) => void) {
		const callbackWrapper = (args: any[], event: any) => {
			const _event: Record < string, any > = {};

			for (let i = 0; i < args.length; i++) {
				_event[event.args[i]!.name] = args[i]!.toJSON();
			}

			callback(handleEventReturn(_event, EVENT_TYPE['PairCreateLocked']) as EventTypes.PairCreateLocked);
		};

		return this.__subscribeOnEvent(callbackWrapper, (eventName : string) => eventName == 'PairCreateLocked');
	}

	public subscribeOnPairCreateUnlockedEvent(callback : (event : EventTypes.PairCreateUnlocked) => void) {
		const callbackWrapper = (args: any[], event: any) => {
			const _event: Record < string, any > = {};

			for (let i = 0; i < args.length; i++) {
				_event[event.args[i]!.name] = args[i]!.toJSON();
			}

			callback(handleEventReturn(_event, EVENT_TYPE['PairCreateUnlocked']) as EventTypes.PairCreateUnlocked);
		};

		return this.__subscribeOnEvent(callbackWrapper, (eventName : string) => eventName == 'PairCreateUnlocked');
	}

	public subscribeOnBootstrapSettedEvent(callback : (event : EventTypes.BootstrapSetted) => void) {
		const callbackWrapper = (args: any[], event: any) => {
			const _event: Record < string, any > = {};

			for (let i = 0; i < args.length; i++) {
				_event[event.args[i]!.name] = args[i]!.toJSON();
			}

			callback(handleEventReturn(_event, EVENT_TYPE['BootstrapSetted']) as EventTypes.BootstrapSetted);
		};

		return this.__subscribeOnEvent(callbackWrapper, (eventName : string) => eventName == 'BootstrapSetted');
	}


	private __subscribeOnEvent(
		callback : (args: any[], event: any) => void,
		filter : (eventName: string) => boolean = () => true
	) {
		// @ts-ignore
		return this.__api.query.system.events((events) => {
			events.forEach((record: any) => {
				const { event } = record;

				if (event.method == 'ContractEmitted') {
					const [address, data] = record.event.data;

					if (address.toString() === this.__nativeContract.address.toString()) {
						const {args, event} = this.__nativeContract.abi.decodeEvent(data);

						if (filter(event.identifier.toString()))
							callback(args, event);
					}
				}
			});
		});
	}

}
